import axios from 'axios';
import { Attributo, IdVersion, AttributoCreateCommand, AttributoUpdateCommand } from '../types';
import { utilityService } from './common/utility-service';

const baseUrl = '/api/v1/attributi';

export const getByTipo = async (tipo: string | null, parent: number | null): Promise<Attributo[]> => {
    return (await axios.get(`${baseUrl}/tipo/${tipo ?? ''}/${parent ?? ''}`)).data;
};

export const getByKey = async (id: number): Promise<Attributo> => {
    return (await axios.get(`${baseUrl}/${id}`)).data;
};

export const create = async (command: AttributoCreateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/create`, command)).data;
};

export const update = async (command: AttributoUpdateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/update`, command)).data;
};

export const remove = async (items: IdVersion[]): Promise<void> => {
    return (await axios.delete(`${baseUrl}/remove?${utilityService.toQueryStringMultiple(items)}`)).data;
};